import { FloatButton } from "antd"

const UpDownButton = () => {
  return ( <FloatButton.BackTop />) 
}

export default UpDownButton

